import { callDecimal } from "../utils.ts";
import { ManageAssetWithLicense } from "../common-types/manageAssets.ts";

export interface SearchCountResponse {
  asset: ManageAssetWithLicense;
  count: number;
  type: string;
  vbid: string;
}

interface MatchData {
  score: number;
  hasExactMatches: boolean;
}

export interface SearchMatches {
  author: MatchData;
  title: MatchData;
  vbid: MatchData;
}

export interface SearchTitleResponse {
  asset: ManageAssetWithLicense;
  matches: SearchMatches;
  score: number;
  type: string;
}

export async function searchLicensesCounts(
  query: string,
  params?: {
    sort?: string;
    page?: { size?: number; next?: string };
  }
) {
  const queryParams = new URLSearchParams();
  queryParams.set("q", query);
  if (params?.sort) {
    queryParams.set("sort", params.sort);
  }
  if (params?.page?.size) {
    queryParams.set("page[size]", params.page.size.toString());
  }
  if (params?.page?.next) {
    queryParams.set("page[next]", params?.page?.next);
  }
  const response = await callDecimal<SearchCountResponse[]>(
    `/api/v1/search?${queryParams.toString()}`
  );
  return response;
}

export async function searchLicensesTitles(query: string) {
  const queryParams = new URLSearchParams();
  queryParams.set("q", query);

  const response = await callDecimal<SearchTitleResponse[]>(
    `/api/v1/search/metadata?${queryParams.toString()}`
  );
  return response;
}
